import { api } from '@marine/api-client/api';
import type { PreferencesTree } from '@/types/preferences';

/**
 * Tenant preferences live on `Employee` (tenant DB) via /api/preferences.
 * The tenant SPA always runs in tenant context, so the endpoint is fixed.
 */
function endpoint(): string {
  return '/api/preferences';
}

export async function patchPreference(path: string, value: unknown): Promise<PreferencesTree> {
  return api.patchOne<PreferencesTree>(endpoint(), { path, value });
}

export async function deletePreference(path: string): Promise<PreferencesTree> {
  // `api.deleteOne` doesn't accept a body; use the raw axios wrapper.
  const response = await api.delete<{ data: PreferencesTree }>(endpoint(), {
    data: { path },
  });
  return response.data.data;
}
